import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductItems } from '../../../../../../models/product/get-product-request';
import { UOMCategory } from '../../../../../../models/product/uom-category';

@Component({
  selector: 'app-uom-tab',
  templateUrl: './uom-tab.component.html',
  styleUrls: ['./uom-tab.component.scss']
})
export class UomTabComponent implements OnInit {
  @Input() product: ProductItems | null = null;
  @Input() uomFormGroup!: FormGroup;
  @Output() uomDataChanged = new EventEmitter<any>();
  selectedUOMCategory!: any; // TODO: Change to model
  UOMCategoryList: any[] = UOMCategory.UOMCategoryList;
  selectedUOMSubCategory!: any;
  UOMSubCategoryList: any[] = [];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    if (this.uomFormGroup) {
      this.setupFormValueChanges();
    }
  }

  private setupFormValueChanges(): void {
    this.uomFormGroup.valueChanges.subscribe((data) => {
      this.emitUomData();
    });
  }

  public getSelectedUOM() {
    if (this.selectedUOMCategory?.name === 'Units') {
      this.uomFormGroup.get('Units')?.disable();
    } else {
      this.uomFormGroup.get('Units')?.enable();
    }
    this.UOMSubCategoryList = UOMCategory.getUOM(
      this.selectedUOMCategory.value
    );
  }

  onUOMCategoryChange(): void {
    this.getSelectedUOM();
    this.emitUomData();
  }

  onMeasurementChange(): void {
    this.emitUomData();
  }

  onUnitsChange(): void {
    this.emitUomData();
  }

  emitUomData(): void {
    const uomData = {
      UOM: this.selectedUOMCategory?.name || '',
      UnitId: this.selectedUOMSubCategory?.value || 0,
      UnitText: this.selectedUOMSubCategory?.name || '',
      Units: this.uomFormGroup.get('Units')?.value || 0,
      Quantity: this.uomFormGroup.get('Units')?.value || 0
    };
    this.uomDataChanged.emit(uomData);
  }

  // Method to get current UOM data (can be called from parent)
  getCurrentUomData(): any {
    const uomData = {
      UOM: this.selectedUOMCategory?.name || '',
      UnitId: this.selectedUOMSubCategory?.value || 0,
      UnitText: this.selectedUOMSubCategory?.name || '',
      Units: this.uomFormGroup.get('Units')?.value || 0,
      Quantity: this.uomFormGroup.get('Units')?.value || 0
    };
    return uomData;
  }
}
